import axios from '@/libs/api.request'

export const getOrgTreeData = () => {
    return axios.request({
        url: '/api/admin/org/list',
        method: 'post'
    })
}